import React from 'react'

export default function Intgration() {
  return (
    <div>
      <h1>Integration</h1>
    </div>
  )
}
